var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useAccount } from 'wagmi';
import { useWalletClient } from 'wagmi';
import { SiweMessage } from 'siwe';
import { useEffect, useState } from 'react';
import { ethers } from 'ethers';
import { ProviderType } from '@lit-protocol/constants';
import { LitAbility, LitPKPResource, LitActionResource, RecapSessionCapabilityObject, } from '@lit-protocol/auth-helpers';
import { useLocalStorage } from 'usehooks-ts';
import { useSession } from '@/contexts/LitSessionProvider';
import signMessageWithActionWrapper from '@/lib/executorHelpers/signMessageWithActionWrapper';
export default function useWalletAuthSig() {
    var _this = this;
    var litNetwork = useSession().litNetwork;
    var account = useAccount().address;
    var _a = useWalletClient(), walletClient = _a.data, isError = _a.isError, isLoading = _a.isLoading;
    var _b = useLocalStorage('authsig', null), authSig = _b[0], setAuthSig = _b[1];
    var _c = useState(null), origin = _c[0], setOrigin = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    useEffect(function () {
        setOrigin(window.location.origin);
    }, []);
    var message = "Signing this message will authenticate you as the owner of the Lit Cloud Wallet tied to your EVM address at ".concat(account, ". Timestamp: ").concat(new Date().toISOString().slice(0, 19).replace('T', ' '), " on ").concat(origin);
    var sign = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
        var authSig_1, recoveredAddress, siweMessage, signature, sessionCapabilityObject, litPkpResource, messageToSign, hexlifiedMessage, response, recoveredAddress_1, e_1;
        var _c;
        var nonce = _b.nonce, pkp = _b.pkp, _d = _b.useLitAction, useLitAction = _d === void 0 ? false : _d, authMethod = _b.authMethod, sessionLength = _b.sessionLength, _e = _b.litActionType, litActionType = _e === void 0 ? ProviderType.Google : _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 5, , 6]);
                    recoveredAddress = void 0;
                    siweMessage = new SiweMessage({
                        domain: 'localhost:3000',
                        address: account,
                        uri: 'localhost:3000',
                        statement: message,
                        version: '1',
                        chainId: 1,
                        nonce: nonce,
                        expirationTime: new Date(Date.now() + sessionLength * 1000).toISOString(),
                    });
                    signature = void 0;
                    console.log('siwe message', siweMessage);
                    if (pkp) {
                        console.log('adding pkp signing capability to siwe message');
                        sessionCapabilityObject = new RecapSessionCapabilityObject({}, []);
                        litPkpResource = new LitPKPResource(pkp.publicKey);
                        sessionCapabilityObject.addCapabilityForResource(litPkpResource, LitAbility.PKPSigning);
                        sessionCapabilityObject.addCapabilityForResource(new LitActionResource(litActionType), LitAbility.LitActionExecution);
                        siweMessage = sessionCapabilityObject.addToSiweMessage(siweMessage);
                        console.log('siwe message with pkp signing capability', siweMessage);
                    }
                    messageToSign = siweMessage.prepareMessage();
                    console.log('message to sign to create wallet authsig', messageToSign);
                    hexlifiedMessage = ethers.utils.arrayify(ethers.utils.keccak256(ethers.utils.toUtf8Bytes(JSON.stringify(messageToSign))));
                    if (!useLitAction) return [3 /*break*/, 2];
                    console.log('signing message with lit action');
                    return [4 /*yield*/, signMessageWithActionWrapper({
                            type: litActionType,
                            authMethods: [authMethod],
                            pkp: pkp,
                            network: litNetwork,
                            environment: 'DEV',
                            message: hexlifiedMessage,
                        })];
                case 1:
                    response = _f.sent();
                    signature = response === null || response === void 0 ? void 0 : response.signature;
                    console.log('signature 29389292', signature);
                    recoveredAddress_1 = ethers.utils.verifyMessage(hexlifiedMessage, signature);
                    console.log('recovered address 29389292', recoveredAddress_1, hexlifiedMessage);
                    authSig_1 = {
                        sig: signature,
                        derivedVia: 'web3.eth.personal.sign',
                        signedMessage: messageToSign,
                        address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
                    };
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, walletClient.signMessage({ account: account, message: messageToSign })];
                case 3:
                    signature = _f.sent();
                    recoveredAddress = (_c = ethers === null || ethers === void 0 ? void 0 : ethers.utils) === null || _c === void 0 ? void 0 : _c.verifyMessage(messageToSign, signature);
                    authSig_1 = {
                        sig: signature,
                        derivedVia: 'web3.eth.personal.sign',
                        signedMessage: messageToSign,
                        address: recoveredAddress,
                    };
                    _f.label = 4;
                case 4:
                    setAuthSig(authSig_1);
                    console.log('authSig', authSig_1, 'signature', signature, 'recoveredAddress', recoveredAddress);
                    return [2 /*return*/, {
                            authSig: authSig_1,
                            signature: signature,
                            recoveredAddress: recoveredAddress,
                            messageToSign: messageToSign,
                        }];
                case 5:
                    e_1 = _f.sent();
                    console.log('error signing message', e_1);
                    setError('Error signing message');
                    return [2 /*return*/, { error: 'Error signing message' }];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return {
        authSig: authSig,
        sign: sign,
    };
}
